import { makeStyles } from "@material-ui/core";

export const useDialogStyles = makeStyles((theme) => ({
  dialogTitle: {
    padding: theme.spacing(3, 3, 1),
  },
  dialogContent: {
    padding: theme.spacing(2, 3, 0),
    "&:first-child": {
      paddingTop: theme.spacing(2),
    },
  },
  dialogContentDividers: {
    padding: theme.spacing(2, 3),
  },
  dialogActions: {
    padding: theme.spacing(3),
    justifyContent: "flex-end",
    gap: theme.spacing(1.5),
  },
  actionButton: {
    width: 160,
    maxWidth: "100%",
  },
  stackedContent: {
    display: "grid",
    gap: theme.spacing(1.5),
  },
  helperText: {
    color: theme.palette.text.secondary,
  },
}));
